/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Destination_TypeInputs */

const en_reference_field_destination_type = /** @type {(inputs: Reference_Field_Destination_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destination`)
};

/**
* | output |
* | --- |
* | "Destination" |
*
* @param {Reference_Field_Destination_TypeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_destination_type = /** @type {((inputs?: Reference_Field_Destination_TypeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Destination_TypeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_destination_type(inputs)
});